import * as React from 'react';
import {
    TabbedForm,
    FormTab,
    useTranslate,
    TextInput, useGetList,
} from 'react-admin';
import {Box, Typography} from "@material-ui/core";
import PostEditDeleteActions from "../../_common/PostEditDeleteActions";
//import {validateSumaRec} from "../utils/validateTable";
import {DateFieldComp} from "../../_common/CompReact";

import {MyTranslatableInputs} from "../../_common/MyTranslatableInputs";
// import {validateEmail} from "../utils/components/validateTable";
import {useEffect, useState} from "react";
import {getPromptForTable} from "../../_common/CompFormat/utils";
import VariantsColors from "./VariantsColors";

const BlockEdit = props => {
    const translate = useTranslate();
    const {related_id} = props
    const {promptData} = props;
    // const locale = useLocale();
    // const formEdit = useForm();

    return (
        <Box p="1em" fullWidth>

            <Box display="flex" alignItems={"top"}>
                <Box flex={1} mr={'2em'}>
                    <MyTranslatableInputs
                        prompt={promptData.find(x => x.field === 'name')}
                        fullWidth
                        source={'name'}
                        label={translate('Name')}
                    />
                </Box>
                <Box flex={1} mr={'2em'}>
                    <TextInput
                        variant={"outlined"}
                        source={'rgb_code'}
                        label={translate('Rgb Code')}
                        fullWidth
                    />
                </Box>
                <Box flex={1}>
                    <TextInput
                        variant={"outlined"}
                        source={'url'}
                        label={translate('Url')}
                        fullWidth
                    />
                </Box>
            </Box>

            {related_id &&
                <Box display="grid" alignItems={"top"}>
                    <Box flex={1} mb={"1em"}
                         style={{border: '1px solid #ddd', borderRadius: 8, padding: '1em'}}
                    >
                        <h4 style={{margin: 0}}>{translate("VariantsColors")}</h4>
                        <VariantsColors related_id={related_id}/>
                    </Box>
                </Box>
            }
        </Box>
    )
}
export const ColorEditCreate = props => {//Не работает

    const translate = useTranslate();
    const {record, resource} = props;
    const {id} = record || {};

    const [promptData, setPromptData] = useState([]);
    const {data: dataPrompts, loading: isLoading} = useGetList(
        "dPrompts",
        {page: 1, perPage: 100},
        {field: 'id', order: 'ASC'},
    );

    useEffect(() => {
        if (dataPrompts) {
            let dt = getPromptForTable(dataPrompts, resource)
            setPromptData(dt)
        }
    }, [dataPrompts, isLoading]);// eslint-disable-line


    return (
        <Box>

            <TabbedForm
                {...props}
                //initialValues={{source: localStorage.getItem('username')}}
                defaultValue={{source: localStorage.getItem('username')}}
                toolbar={<PostEditDeleteActions goBack={false}/>}
                //redirect={redirect_url}
            >
                <FormTab label={translate('Common')}>
                    <BlockEdit
                        {...props}
                        related_id={id}
                        promptData={promptData}
                    />
                </FormTab>
                {/*{id &&
                    <FormTab label={translate('Seo')}>
                        <Seo
                            {...props}
                            resource={'dMenuItems'}
                            id={id}
                            promptData={promptData}
                        />
                    </FormTab>
                }*/}
                {/*<FormTab label={translate('Media')}>
                    <BlockEditImg
                        {...props}
                        related_id={id}
                        //promptData={promptData}
                    />
                </FormTab>*/}
            </TabbedForm>

            {id &&
                <Box display="flex" alignItems={"center"} p="1em">
                    <Box display="flex" flex={1} mr="2em" alignItems={"center"}>
                        <Box flex={1} style={{display: "flex"}} mr={'2em'}>
                            <Typography variant="subtitle2"
                                        gutterBottom>{translate('Source')}: <b>{record.source}</b></Typography>
                        </Box>
                    </Box>
                    <Box flex={1} align={'end'}>
                        <Box display="grid">
                            <div>Updated: <DateFieldComp source="updated" variant="subtitle2" fullWidth/></div>
                        </Box>
                    </Box>
                </Box>
            }

        </Box>
    )
};

export default ColorEditCreate
